import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cos-form-item-detail cos-form-item-input-detail"
}
const _hoisted_2 = ["title"]

import { computed } from 'vue'
import { getTreeNameList } from '@/utils'
import useHook from './useHook'


const __default__ = { name: 'CustomerLabelCascaderText' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    appId: {},
    value: {},
    view: { type: Boolean },
    multiple: { type: Boolean },
    lastLeval: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const { customerLabelEnum } = useHook(props.appId)

const valueFormat = computed(() => {
  if (props.value == null) return '--'
  const config = props.appId === 'cos_lbu' ? { label: 'name' } : { label: 'label' }
  if (props.multiple) {
    const labelArray: any = []
    if (props.value && Array.isArray(props.value)) {
      props.value.forEach((val) => {
        const labelList = getTreeNameList(customerLabelEnum.value, val, config).filter((name) => name)
        if (props.lastLeval && labelList?.length) {
          labelArray.push(labelList[labelList.length - 1])
        } else {
          labelArray.push(labelList.join('/'))
        }
      })
    }
    return labelArray.join(';') || '--'
  } else {
    const labelList = getTreeNameList(customerLabelEnum.value, props.value, config).filter((name) => name)
    return labelList.join('/') || '--'
  }
})
const titleFormat = computed(() => {
  return valueFormat.value === '--' ? '' : valueFormat.value
})

return (_ctx: any,_cache: any) => {
  return (_ctx.view)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(valueFormat.value || '--'), 1)
      ]))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        title: titleFormat.value
      }, _toDisplayString(valueFormat.value), 9, _hoisted_2))
}
}

})